module.exports = __webpack_public_path__ + "d6beaa783d4b7781a322feb32c45e01d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_01.jpg
// module id = aNPG
// module chunks = 0